import { render, staticRenderFns } from "./TickInvalid.vue?vue&type=template&id=2206a6ca&"
import script from "./TickInvalid.vue?vue&type=script&lang=js&"
export * from "./TickInvalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports